// extracted by mini-css-extract-plugin
module.exports = {"section02":"Section2_section02__VxXTh"};